/* global Vue */
/* global Homie */
require('../config/init');

import VueRouter from 'vue-router';
Vue.use(VueRouter);
import OnboardingRoutes from '../shared/routes/onboarding';
import axios from 'axios';

let router =  new VueRouter({
  routes: OnboardingRoutes
});

router.beforeEach((to, from, next) => {
  if(to.query.campaign){
    axios.post( `/utilities/check_for_campaign`,
      {
        campaign: to.query.campaign
      }
    ).then(response => {
      if(response.data.hide_header){
        $("header").remove();
      }
    });
  }

  if (to.meta.requiredAuth) {
    if (!Homie.is_logged) {
      return next({name: 'auth.login'});
    }
  }
  next();
});
export default router;